module.exports = __webpack_public_path__ + "67d3d63c0ac28ccbc0c0fcbda8e66e04.woff";